export default __webpack_public_path__ + "static/media/hero-image.b185181d.webp";